import { useTranslation } from 'react-i18next';

import { Container } from '@/ui';
import { ScoringCategory, ScoringCategoryList } from '@/features/constructorScoringCategory';
import { Typography } from 'antd';

export const ConstructorScoringCategory = () => {
  const { t } = useTranslation();

  return (
    <Container $paddingY={20}>
      <Container $marginBottom={30}>
        <Typography.Title level={3}>{t('Constructor scoring categories')}</Typography.Title>
      </Container>

      <ScoringCategoryList />
      <ScoringCategory />
    </Container>
  );
};
